<template lang="pug">
  v-stepper.pb-2.my-2(v-model="form.stepVisible" vertical)

    //- step 1
    v-stepper-step.pl-2.pl-sm-6(:complete="form.stepVisible > 1" step="1", :editable="form.step1.editable") {{translations.steps.step1}}
    v-stepper-content.ml-5.ml-sm-9(step="1")
      ValidationObserver(v-slot="{ invalid, handleSubmit }" ref="validator1")
        v-form.pb-10(@submit.prevent="handleSubmit(onSubmitStep1)")
          BaseSelectField(rules="required", :items="form.step1.matchsetType.items" v-model="form.step1.matchsetType.value", :label="translations.form.matchsetType")
          v-btn.float-right.big(color="primary" type="submit", :disabled="invalid") {{translations.buttons.next}}

    //- step 2
    v-stepper-step.pl-2.pl-sm-6(:complete="form.stepVisible > 2" step="2", :editable="form.step2.editable") {{translations.steps.step2}}
    v-stepper-content.ml-5.ml-sm-9(step="2")
      //- step 2 - case Match
      ValidationObserver(v-if="form.step1.matchsetType.value == '1'" v-slot="{ invalid, handleSubmit }" ref="validator2")
        v-form.pb-10(@submit.prevent="handleSubmit(onSubmitStep2)")
          v-container.px-0.px-sm-4(fluid)
            v-row
              v-col(cols="12")
                BaseTextField(rules="required" v-model="form.step2.match.name", :label="translations.form.name")
              v-col(cols="12")
                ValidationProvider(rules="required" v-slot="{ errors }")
                  v-select(:items="form.step2.match.competition.items" item-text="text" item-value="id" return-object @change="loadMatches(form.step2.match.competition.value.id)" v-model="form.step2.match.competition.value", :error="errors.length > 0")
                    template(v-slot:label)
                      v-icon.pr-1(color="red accent-2" size="12") mdi-asterisk
                      | {{ translations.form.competition }}
                  span.red--text.text--accent-2(v-if="errors.length > 0")
                    v-icon(color="red accent-2") mdi-alert
                    |  {{ errors[0] }}
              v-col(cols="12")
                p.red--text(v-if="form.step2.match.competition.value.id == null") {{ translations.form.matchesInfo }}
                BaseChipSelectField(rules="required", :items="form.step2.match.matches.items" v-model="form.step2.match.matches.value", :label="translations.form.matches", :disabled="form.step2.match.competition.value.id == null || loadingMatches")
              v-col(cols="12")
                BaseTextField(rules="required|numeric" v-model="form.step2.match.matchday", :label="translations.form.matchday")
          v-btn.float-right.big(color="primary" @click="form.stepVisible = 3" type="submit", :disabled="invalid") {{translations.buttons.next}}
      //- step 2 - case Round
      ValidationObserver(v-else-if="form.step1.matchsetType.value == '2'" v-slot="{ invalid, handleSubmit }" ref="validator3")
        v-form.pb-10(@submit.prevent="handleSubmit(onSubmitStep2)")
          v-container(fluid)
            v-row
              v-col(cols="12")
                BaseTextField(rules="required" v-model="form.step2.round.name", :label="translations.form.name")
              v-col(cols="12")
                ValidationProvider(rules="required" v-slot="{ errors }")
                  v-select(:items="form.step2.round.competition.items" item-text="text" item-value="id" return-object v-model="form.step2.round.competition.value", :error="errors.length > 0")
                    template(v-slot:label)
                      v-icon.pr-1(color="red accent-2" size="12") mdi-asterisk
                      | {{ translations.form.competition }}
                  span.red--text.text--accent-2(v-if="errors.length > 0")
                    v-icon(color="red accent-2") mdi-alert
                    |  {{ errors[0] }}
              v-col(cols="12")
                BaseTextField(rules="required|numeric" v-model="form.step2.round.matchday", :label="translations.form.matchday")
          v-btn.float-right.big(color="primary" type="submit", :disabled="invalid") {{translations.buttons.next}}
      //- step 2 - case Day
      ValidationObserver(v-else-if="form.step1.matchsetType.value == '3'" v-slot="{ invalid, handleSubmit }" ref="validator4")
        v-form.pb-10(@submit.prevent="handleSubmit(onSubmitStep2)")
          v-container(fluid)
            v-row
              v-col(cols="12")
                BaseTextField(rules="required" v-model="form.step2.day.name", :label="translations.form.name")
              v-col(cols="12")
                ValidationProvider(rules="required" v-slot="{ errors }")
                  v-select(:items="form.step2.day.competition.items" item-text="text" item-value="id" return-object v-model="form.step2.day.competition.value", :error="errors.length > 0")
                    template(v-slot:label)
                      v-icon.pr-1(color="red accent-2" size="12") mdi-asterisk
                      | {{ translations.form.competition }}
                  span.red--text.text--accent-2(v-if="errors.length > 0")
                    v-icon(color="red accent-2") mdi-alert
                    |  {{ errors[0] }}
              v-col(cols="12")
                BaseDatePicker(rules="required" v-model="form.step2.day.date", :label="translations.form.date")
              v-col(cols="12")
                BaseTextField(rules="required|numeric" v-model="form.step2.day.matchday", :label="translations.form.matchday")
          v-btn.float-right.big(color="primary" type="submit", :disabled="invalid") {{translations.buttons.next}}

    //- step 3
    v-stepper-step.pl-2.pl-sm-6(:complete="form.stepVisible > 3" step="3", :editable="form.step3.editable") {{translations.steps.step3}}
    v-stepper-content.ml-5.ml-sm-9(step="3")
      v-container.px-0.px-sm-4.py-0(fluid)
        v-row
          v-col.py-0(cols="12" v-if="form.step1.matchsetType.value == '1'")
            dl
              v-row
                v-col(cols="12" lg="4" md="4" sm="6")
                  dt {{ translations.form.name }}
                v-col(cols="12" lg="8" md="8" sm="6")
                  dd {{ form.step2.match.name }}
                v-col(cols="12" lg="4" md="4" sm="6")
                  dt {{ translations.form.matches }}
                v-col(cols="12" lg="8" md="8" sm="6")
                  dd(v-for="match, i in form.step2.match.matches.value", :key="'match'+i") {{ match.text }}
                v-col(cols="12" lg="4" md="4" sm="6")
                  dt {{ translations.form.competition }}
                v-col(cols="12" lg="8" md="8" sm="6")
                  dd {{ form.step2.match.competition.value.text }}
                v-col(cols="12" lg="4" md="4" sm="6")
                  dt {{ translations.form.matchday }}
                v-col(cols="12" lg="8" md="8" sm="6")
                  dd {{ form.step2.match.matchday }}
          v-col.py-0(cols="12" v-else-if="form.step1.matchsetType.value == '2'")
            dl
              v-row
                v-col(cols="12" lg="4" md="4" sm="6")
                  dt {{ translations.form.name }}
                v-col(cols="12" lg="8" md="8" sm="6")
                  dd {{ form.step2.round.name }}
                v-col(cols="12" lg="4" md="4" sm="6")
                  dt {{ translations.form.competition }}
                v-col(cols="12" lg="8" md="8" sm="6")
                  dd {{ form.step2.round.competition.value.text }}
                v-col(cols="12" lg="4" md="4" sm="6")
                  dt {{ translations.form.matchday }}
                v-col(cols="12" lg="8" md="8" sm="6")
                  dd {{ form.step2.round.matchday }}
          v-col.py-0(cols="12" v-else-if="form.step1.matchsetType.value == '3'")
            dl
              v-row
                v-col(cols="12" lg="4" md="4" sm="6")
                  dt {{ translations.form.name }}
                v-col(cols="12" lg="8" md="8" sm="6")
                  dd {{ form.step2.day.name }}
                v-col(cols="12" lg="4" md="4" sm="6")
                  dt {{ translations.form.competition }}
                v-col(cols="12" lg="8" md="8" sm="6")
                  dd {{ form.step2.day.competition.value.text }}
                v-col(cols="12" lg="4" md="4" sm="6")
                  dt {{ translations.form.matchday }}
                v-col(cols="12" lg="8" md="8" sm="6")
                  dd {{ form.step2.day.matchday }}
                v-col(cols="12" lg="4" md="4" sm="6")
                  dt {{ translations.form.date }}
                v-col(cols="12" lg="8" md="8" sm="6")
                  dd {{ form.step2.day.date }}
      v-btn.float-right.big(color="primary" @click="submitDataForm", :loading="loadingCreate") {{translations.buttons.create}}

</template>

<script>

  export default {
    name: "MatchsetCreate",
    props: {
      clearForm: {
        type: Boolean,
        default: false
      },
      translations: {
        type: Object,
        default: function(){
          return {}
        }
      },
    },
    data:() => ({
      form:{
        stepVisible: 1,
        step1: {
          editable: true,
          matchsetType: {
            value: null,
            items: [
              {
                text: 'Match',
                value: '1'
              },
              {
                text: 'Round',
                value: '2'
              },
              {
                text: 'Day',
                value: '3'
              }
            ]
          }
        },
        step2:{
          editable: false,
          match:{
            name: null,
            competition: {
              value: {
                text: null,
                id: null
              },
              items: []
            },
            matches: {
              value: null,
              items: null
            },
            matchday: null
          },
          round: {
            name: null,
            competition: {
              value: {
                text: null,
                id: null
              },
              items: []
            },
            matchday: null
          },
          day: {
            name: null,
            competition: {
              value: {
                text: null,
                id: null
              },
              items: []
            },
            date: null,
            matchday: null
          }
        },
        step3: {
          editable: false,
        },
      },
    }),
    computed: {
      competitionListAll() {
        return this.$store.state.fantasy.competitions.map(competition => (
          {
            text: competition.name,
            id: competition._id
          }
        ));
      },
      matchesListAll() {
        return this.$store.state.fantasy.matches.map(match => (
          {
            text: match.home.name + ' - ' + match.away.name,
            value: match._id
          }
        ));
      },
      loadingMatches() {
        return this.$store.state.statusCode.getMatches.loading;
      },
      loadingCreate() {
        return this.$store.state.statusCode.createMatchset.loading;
      },
      stateCreate() {
        return this.$store.state.statusCode.createMatchset.state;
      },
    },
    watch: {
      clearForm: function(val){
        if(val) {
          this.clearFields();
          if(this.$refs.validator1) {
            this.$refs.validator1.reset();
          }
          if(this.$refs.validator2) {
            this.$refs.validator2.reset();
          }
          if(this.$refs.validator3) {
            this.$refs.validator3.reset();
          }
          if(this.$refs.validator4) {
            this.$refs.validator4.reset();
          }
        }
      },
      stateCreate: function(val){
        if (val == 200) {
          this.$emit('successCreate');
        }
      },
      competitionListAll: function (val) {
        this.form.step2.match.competition.items = val;
        this.form.step2.round.competition.items = val;
        this.form.step2.day.competition.items = val;
      },
      matchesListAll: function (val) {
        this.form.step2.match.matches.items = val;
      },
    },
    created(){
      this.clearFields();

      this.$store.dispatch('getCompetitions');
    },
    methods:{
      onSubmitStep1(){
        this.form.stepVisible = 2;
        this.form.step2.editable = true;
      },
      onSubmitStep2(){
        this.form.stepVisible = 3;
        this.form.step3.editable = true;
      },
      submitDataForm(){
        let formSend;
        if(this.form.step1.matchsetType.value == '1'){
          formSend = {
            data: {
              name: this.form.step2.match.name,
              competition: this.form.step2.match.competition.value.id,
              matches: this.form.step2.match.matches.value.map(item=>item.value),
              matchday: parseInt(this.form.step2.match.matchday)
            }
          }
        } else if(this.form.step1.matchsetType.value == '2'){
          formSend = {
            data: {
              name: this.form.step2.round.name,
              competition: this.form.step2.round.competition.value.id,
              matchday: parseInt(this.form.step2.round.matchday)
            }
          }
        } else if(this.form.step1.matchsetType.value == '3'){
          formSend = {
            data: {
              name: this.form.step2.day.name,
              competition: this.form.step2.day.competition.value.id,
              matchday: parseInt(this.form.step2.day.matchday),
              date: this.form.step2.day.date
            }
          }
        }
        this.$store.dispatch('createMatchset', formSend);
      },
      clearFields(){
        this.form.stepVisible = 1;
        this.form.step1.editable = true;
        this.form.step1.matchsetType.value = null;
        this.form.step2.editable = false;
        this.form.step2.match.name = null;
        this.form.step2.match.competition.value.text = null;
        this.form.step2.match.competition.value.id = null;
        this.form.step2.match.matches.value = null;
        this.form.step2.match.matchday = null;
        this.form.step2.round.name = null;
        this.form.step2.round.competition.value.text = null;
        this.form.step2.round.competition.value.id = null;
        this.form.step2.round.matchday = null;
        this.form.step2.day.name = null;
        this.form.step2.day.competition.value.text = null;
        this.form.step2.day.competition.value.id = null;
        this.form.step2.day.date = null;
        this.form.step2.day.matchday = null;
        this.form.step3.editable = false;
        this.$store.dispatch('getCompetitions');
      },
      loadMatches(competitionid){
        // vaciando antes de usar para que no aparezcan matches de otras competiciones
        this.$store.commit('getMatches', []);
        
        this.$store.dispatch('getMatches', competitionid);
      },
    }
  }
</script>

<style lang="sass">
</style>